<template>
  <div>
    <div class="top-bar d-flex justify-content-between px-4">
      <span class="text-center flex-grow-1"> {{ $t('Refer a friend & get $50 in credits each 🎉') }}</span>
      <li v-for="(item, index) in this.countries" class="nav-item dropdown ">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
          aria-expanded="false" style="color:white !important">
          <img :src="item.image" :alt="item.name" width="20px"> {{ item.name }}
        </a>

      </li>
    </div>
    <nav class="navbar navbar-expand-lg bg-white shadow-sm">
      <div class="container-fluid">

        <!-- الشعار -->
        <img :src="this.$store.state.logo" class="logo ">
        <!-- زر القائمة للموبايل -->
        <button @click="openPopup('popupContainer4')" class="navbar-toggler order-first" type="button"
          data-bs-toggle="collapse" data-bs-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false"
          aria-label="Toggle navigation">
          <span class="navbar-toggler-icon fa fa-bars"></span>
        </button>

        <!-- مربع البحث -->
        <div class="te_header_search ">
          <div class="te_search_popover" tabindex="-1">
            <div class="o_searchbar_form o_wait_lazy_js s_searchbar_input " data-snippet="s_searchbar_input">
              <div role="search" class="input-group " id="search_div">
                <input type="search" class="search-query form-control oe_search_box None search-box"
                  :aria-label="$t('search')" aria-describedby="search-addon" v-model="word" @keyup.enter="searchRoute"
                  id="search" autocomplete="false" onblur="this.setAttribute('readonly', 'readonly') , word=''"
                  onfocus="this.removeAttribute('readonly');" readonly data-search-type="products_only" data-limit="5"
                  data-display-image="true" data-display-description="false" data-display-extra-link="true"
                  data-display-detail="true" data-order-by="name asc">
                <div class="te_header_search_close te_srch_close_ept" style="z-index: 100; display: none;">
                  <a @click="searchRoute">
                    <span class="search_btn_close_ept"></span>
                  </a>
                </div>
                <button type="submit" aria-label="Search" title="Search"
                  class="oe_search_button btn-primary but_search">
                  <i class="fa fa-search" style="font-size: 20px;color: #2D2E2F ;font-weight: normal"></i>
                </button>
              </div>

              <input name="order" type="hidden" class="o_search_order_by" value="name asc">


            </div>
          </div>
        </div>

        <!-- أيقونات المستخدم والسلة -->
        <div class="icon-container">
          <i class="fa fa-search" style="font-size: 20px;color: #2D2E2F ;font-weight: normal;" @click="show_search"id="search2"></i>
          <!-- أيقونة السلة مع العدد -->
          <a @click="show_cart_fun(); openPopup('popupContainer2'); activeMobile = false" class="position-relative">
            <i class="bi bi-cart fa-lg"></i>
            <span class="cart-badge"> {{ this.$store.state.cartCounter }}</span>
          </a>


          <!-- أيقونة المستخدم -->
          <a v-if="this.$localStorage.get(this.$store.storeName) == null"
            @click="openPopup('popupContainer'); activeMobile = false">
            <i class="fa fa-user-o fa-lg"></i>
          </a>

          <a v-if="this.$localStorage.get(this.$store.storeName) != null"
            @click="openPopup('popupContainer3'); activeMobile = false">
            <i class="fa fa-user-o fa-lg"></i>
          </a>
          <router-link @click="activeMobile = false" :to="{
            name: 'favorites',
            params: { storeName: this.$store.storeName, lang: $store.state.routeLang },
          }" v-if="this.$localStorage.get(this.$store.storeName) != null">
            <i class="fa fa-heart-o fa-lg"></i>
          </router-link>




          <div class="dropdown lang_select" @click="toggleDropdown">
            <button class="d-flex align-items-center lang_btn">
              <i class="fa fa-chevron-down me-2"></i>
            </button>

            <!-- القائمة المنسدلة -->
            <ul class="dropdown-menu show lang_menue" v-show="isOpen">
              <li><a class="dropdown-item" @click="onChange('ar');">العربية</a></li>
              <li><a class="dropdown-item" @click="onChange('en')">English</a></li>
            </ul>
          </div>

        </div>
      </div>
    </nav>


    <div class="bg-white shadow-sm">
      <div class="container-fluid">
        <div class="collapse navbar-collapse show" id="navbarContent">
          <div class="navbar-nav d-flex flex-row justify-content-center w-100" style="padding: 15px;">

            <li class="list_nav_item" @click="activeMobile = false">
              <div class="dropdown container" id="menu_dropdown">
                <router-link :to="{
                  name: 'home',
                  params: { storeName: this.$store.storeName, lang: $i18n.locale },
                }">

                  {{ $t('home') }}
                </router-link>

              </div>
            </li>

            <li v-for="(item, index) in this.sections" class="list_nav_item">
              <div class="dropdown container" id="menu_dropdown">
                <span class="dd pulse"></span>
                <button class="dropdown-toggle" @mouseenter="toggleMenu(item.id)" type="button" id="dropdownMenuButton2"
                  data-bs-toggle="dropdown" aria-expanded="false" style="background-color: transparent; border: none;">
                  {{ item.name }}
                </button>

                <ul @mouseleave="closeMenu(item.id)" class="dropdown-menu section_header_item"
                  :id="'section_' + item.id" aria-labelledby="dropdownMenuLink" style="width: 100%;">

                  <div v-for="(item2, index2) in item.categories" class="dropdown_contain">
                    <img :src="item2.icon" class="dropdown_img"><br>
                    <router-link @click="activeMobile = false" :to="{
                      name: 'section',
                      params: {
                        storeName: $store.storeName,
                        id: item.id,
                        name: item.name,
                        lang: $i18n.locale
                      },
                    }" class="dropdown_text" @click.prevent="handleItemClick(item.id)">{{ item2.name
                    }}</router-link>
                  </div>

                </ul>
              </div>
            </li>


          </div>
        </div>
      </div>
    </div>


    <!-- login popup -->
    <div id="popupContainer" class="popup-container">

      <div class="popup-content">
        <button @click="closePopup('popupContainer')"
          style="float: inline-end; margin-top: -5%; color:#c9c9c9;background-color: transparent; border-color: transparent; font-size: 25px;">x</button>
        <div class=" d-flex justify-content-between">

          <a href="#" id="login2" class="login_link login_active" @click="close_auth(); openPopup('login');">
            {{ $t('login') }}</a>
          <a href="#" id="register2" class="login_link" @click="close_auth(); openPopup('register');">
            {{ $t('register') }}</a>

        </div>

        <!--  -->
        <div id="register" style="display:none" class="auth_class">
          <form @submit.prevent="sendEmail" @keydown="form.onKeydown($event)">
            <div style="display: block;margin-left: auto; margin-right: auto; text-align: center;">
              <label for="uname"><span>{{ $t('email') }}</span></label>
              <br>
              <input class="input_login" type="email" autocomplete="false" :placeholder="$t('email')"
                v-model="form.email" maxlength="255" minlength="3">
            </div>

            <br>
            <div style="text-align: center;">
              <button type="submit" :disabled="form.busy" class="login_button">
                <i class="fa fa-spinner fa-spin " v-if="loading_register"></i>
                {{ $t("continue") }}</button>


            </div>
            <div v-if="errorMessage != ''" style="
                text-align: center;
                padding: 5px;
                background-color: #fff;
                display: inline;
                margin: 0 10px;
              ">
              <span style="margin: 0; color: red; display: inline">{{
                errorMessage
              }}</span>
            </div>
          </form>
        </div>
        <!-- register2 -->

        <!--  -->
        <div id="complate_register" style="display:none" class="auth_class">
          <form @submit.prevent="submitInfo" @keydown="form.onKeydown($event)">

            <div style="display: block;margin-left: auto; margin-right: auto; text-align: center;">
              <label for="uname"><span>{{ $t('phone') }}</span></label>
              <br>
              <input class="input_login" type="text" autocomplete="false" v-model="form.phone_basic"
                :minlength=$store.state.country_length :maxlength=$store.state.country_length style="text-align:center">

              <span class="flag">
                <h2>{{ $store.state.country_code }}</h2>

              </span>
            </div>

            <br>

            <div style="display: block;margin-left: auto; margin-right: auto; text-align: center;">
              <label for="uname"><span>{{ $t('name') }}</span></label>
              <br>
              <input class="input_login" type="text" autocomplete="false" v-model="form.name" maxlength="255"
                minlength="3">
            </div>

            <br>

            <div style="display: block;margin-left: auto; margin-right: auto; text-align: center;">
              <label for="uname"><span>{{ $t('password') }}</span></label>
              <br>
              <input class="input_login" type="password" name="name" autocomplete="new-password" v-model="form.password"
                minlength="8">
            </div>

            <br>

            <div style="display: block;margin-left: auto; margin-right: auto; text-align: center;">
              <label for="uname"><span>{{ $t('Confirm Password') }}</span></label>
              <br>
              <input class="input_login" type="password" autocomplete="new-password" name="name"
                v-model="confirmPassword" minlength="8">
            </div>
            <br>

            <div style="text-align: center;">
              <button type="submit" :disabled="form.busy" class="login_button">
                <i class="fa fa-spinner fa-spin " v-if="loading_complate_register"></i>

                {{ $t("continue") }}</button>


            </div>
            <div v-if="errorMessage != ''" style="
                text-align: center;
                padding: 5px;
                background-color: #fff;
                display: inline;
                margin: 0 10px;
              ">
              <span style="margin: 0; color: red; display: inline">{{
                errorMessage
              }}</span>
            </div>
          </form>
        </div>
        <!-- end register -->
        <!-- send code -->
        <div id="register_code" style="display:none" class="auth_class">
          <form @submit.prevent="checkCodeRegister" @keydown="form.onKeydown($event)">
            <div style="display: block;margin-left: auto; margin-right: auto; text-align: center;">
              <label for="uname"><span>{{ $t('code') }}</span></label>
              <br>
              <input class="input_login" type="text" autocomplete="false" maxlength="6" minlength="6"
                style="text-align:center" v-model="code">
            </div>
            <div>

              <p style="margin-top: 15px; margin-bottom: 0 ;text-align:center" v-if="$i18n.locale == 'en'">
                {{ countDown }} second
              </p>
              <p style="margin-top: 15px; margin-bottom: 0;;text-align:center" v-else>
                {{ countDown }} ثانية
              </p>
            </div>

            <br>


            <div style="text-align: center;">
              <button type="submit" v-if="countDown!=0"  :disabled="form.busy" class="login_button">
                <i class="fa fa-spinner fa-spin " v-if="loading_code"></i>

                {{ $t("continue") }}</button>

                  <button v-if="countDown==0" class="login_button"
                   @click="ResendCode()">
                     <i class="fa fa-spinner fa-spin " v-if="loading_code"></i>
            {{ $t("ResendCode") }}
          </button>


            </div>
            <div v-if="errorMessage != ''" style="
                text-align: center;
                padding: 5px;
                background-color: #fff;
                display: inline;
                margin: 0 10px;
              ">
              <span style="margin: 0; color: red; display: inline">{{
                errorMessage
              }}</span>
            </div>
          </form>
        </div>
        <!-- end register -->

        <div id="login" class="auth_class">
          <form @submit.prevent="submitInfoLogin" @keydown="login_form.onKeydown($event)">

            <div style="display: block;margin-left: auto; margin-right: auto; text-align: center;">
              <label for="uname"><span>{{ $t('email') }}</span></label>
              <br>
              <input class="input_login" type="email" v-model="login_form.email" placeholder="example@gmail.com">
            </div>
            <br>
            <div style="display: block; margin-left: auto; margin-right: auto; text-align: center;">
              <label for="uname"><span>{{ $t('password') }}</span></label>
              <br>
              <input class="input_login" type="password" v-model="login_form.password" :placeholder="$t('EnterPass')"
                minlength="8">
            </div>

            <br>
            <div style="text-align: center;">
              <button :disabled="login_form.busy" class=" login_button">
                <i class="fa fa-spinner fa-spin " v-if="loading_login"></i>

                {{ $t('login') }}</button>

            </div>
            <br>
            <a style="padding-left: 8%;" class="reset_password" @click="close_auth(); openPopup('reset_password');">
              {{ $t('forgetpass') }}</a>
          </form>
          <div v-if="errorMessage != ''" style="
                text-align: center;
                padding: 5px;
                background-color: #fff;
                display: inline;
                margin: 0 10px;
              ">
            <span style="margin: 0; color: red; display: inline">{{
              errorMessage
            }}</span>
          </div>
        </div>
        <!--  -->
        <div id="reset_password" style="display:none" class="auth_class">

          <div style="display: block;margin-left: auto; margin-right: auto; text-align: center;">
            <label for="uname"><span>{{ $t('email') }}</span></label>
            <br>
            <input class="input_login" type="text" v-model="passemail">
          </div>
          <br>



          <br>

          <div class="d-flex justify-content-between align-items-center small">
            <button @click="resetpass" type="submit" class="login_button reset_btn_moile" style="padding: 11px 25px; margin-top: 2%;">

              <i class="fa fa-spinner fa-spin " v-if="loading_reset"></i>

              {{ $t('confirm') }}</button>
            <a class="back_login" 
            @click="close_auth(); openPopup('login');">{{ $t('Back to Login') }}</a>
          </div>

           <div v-if="errorMessage != ''" style="
                text-align: center;
                padding: 5px;
                background-color: #fff;
                display: inline;
                margin: 0 10px;
              ">
            <span style="margin: 0; color: red; display: inline">{{
              errorMessage
            }}</span>
          </div>
        </div>
        <!-- check code -->
        <div id="reset_code" style="display:none" class="auth_class">

          <div style="display: block;margin-left: auto; margin-right: auto; text-align: center;">
            <label for="uname"><span>{{ $t('code') }}</span></label>
            <br>
            <input class="input_login" type="text"  v-model="finalcode">
          </div>
          <br>
          <br>
           <div>

              <p style="margin-top: 15px; margin-bottom: 0 ;text-align:center" v-if="$i18n.locale == 'en'">
                {{ countDown }} second
              </p>
              <p style="margin-top: 15px; margin-bottom: 0;;text-align:center" v-else>
                {{ countDown }} ثانية
              </p>
            </div>


          <div class="d-flex justify-content-between align-items-center small">
            <button @click="checkCode" v-if="countDown!=0" type="submit" class="login_button reset_btn_moile" style="padding: 11px 25px; margin-top: 2%;">
              <i class="fa fa-spinner fa-spin " v-if="loading_reset_code"></i>


              {{ $t('confirm') }}</button>

               <button v-if="countDown==0" class="login_button reset_btn_moile"
                   @click="resetpass()">
                     <i class="fa fa-spinner fa-spin " v-if="loading_reset_code"></i>
            {{ $t("ResendCode") }}
          </button>
            <a class="back_login" @click="close_auth(); openPopup('login');">{{ $t('Back to Login') }}</a>
          </div>

           <div v-if="errorMessage != ''" style="
                text-align: center;
                padding: 5px;
                background-color: #fff;
                display: inline;
                margin: 0 10px;
              ">
            <span style="margin: 0; color: red; display: inline">{{
              errorMessage
            }}</span>
          </div>
        </div>
        <!-- end check code -->

        <!-- upd8ate password -->
        <div id="change_password" style="display:none" class="auth_class">

          <div style="display: block;margin-left: auto; margin-right: auto; text-align: center;">
            <label for="uname"><span>{{ $t('password') }}</span></label>
            <br>
            <input class="input_login" type="text" v-model="Newpassword">
          </div>


          <br>

          <div class="d-flex justify-content-between align-items-center small">
            <button @click="SaveChanges" type="submit" class="login_button" style="padding: 11px 25px; margin-top: 2%;">
              <i class="fa fa-spinner fa-spin " v-if="loading_change_password"></i>
              {{ $t('confirm') }}</button>
            <a class="back_login" @click="close_auth(); openPopup('login');">{{ $t('Back to Login') }}</a>
          </div>

           <div v-if="errorMessage != ''" style="
                text-align: center;
                padding: 5px;
                background-color: #fff;
                display: inline;
                margin: 0 10px;
              ">
            <span style="margin: 0; color: red; display: inline">{{
              errorMessage
            }}</span>
          </div>
        </div>
        <!-- end check code -->
        <!-- update password -->

      </div>
    </div>



    <!-- cart -->
    <div id="popupContainer2" class="popup-container">
      <div class="popup-content2">

        <div class="container-fluid">
          <div class=" offcanvas-end " tabindex="-1"
            style="visibility: visible; width: 100%; max-width: 380px; position: fixed; top: 0; right: 0; height: 100%; background: #fff; z-index: 1055; display: flex; flex-direction: column;">

            <!-- Header -->
            <div
              class="offcanvas-header border-bottom d-flex justify-content-between align-items-center p-3  cart_title_header">
              <p class="offcanvas-title mb-0">{{ $t('My Cart') }}</p>
              <button @click="closePopup('popupContainer2')" type="button" class="btn-close" aria-label="Close"
                style="font-size: 0.5rem;"></button>
            </div>
            <div class="empty text-center center-text" v-if="loading_cart">

              <img src="/pet_shop/assets/images/ajax-loader.gif" />

            </div>
            <div class="empty text-center center-text" v-else-if="this.items.length == 0">

              <img src="/theme13/assest/images/cart_empty.webp" />
            </div>
            <!-- Scrollable products area -->
            <div class="flex-grow-1 overflow-auto p-3" id="cartBody" style="min-height: 0;">
              <!-- Product Card -->
              <item_cart v-for="item in this.items" :key="item" :item-id="item"></item_cart>
            </div>

            <!-- Fixed Bottom Section -->
            <div class="border-top p-3 ">
              <div class="d-flex justify-content-between mb-2">
                <span>{{ $t('Subtotal') }}:</span>
                <span>{{ price.toFixed($store.state.digit_price) }} {{ $store.state.UnitPrice }}</span>
              </div>

              <div class="d-flex justify-content-between fw-bold border-top pt-2 mt-2">
                <span>{{ $t('total') }}:</span>
                <span>{{ price.toFixed($store.state.digit_price) }} {{ $store.state.UnitPrice }}</span>
              </div>

              <!-- Clear Cart Button -->
              <div class="text-end mt-2">
                <button v-if="this.items.length != 0" @click="deleteAllCookies"
                  class="btn btn-link text-danger p-0" id="clearCart">
                  <i class="fa fa-trash-o"></i>
                  {{ $t('Clear Cart') }}</button>
              </div>

              <!-- Proceed to Checkout Button -->
              <button class="btn btn-success w-100 mt-3"
                v-if="this.$localStorage.get(this.$store.storeName) != null && this.items.length != 0"
                @click="confirmOrder(); closePopup('popupContainer2')" style="background-color: #5B7847;">{{ $t('Procced to Checkout') }}</button>
              <button class="btn btn-success w-100 mt-3" v-else-if="this.items.length != 0" @click="confirmOrder_guest();closePopup('popupContainer2')"
                style="background-color: #5B7847;">{{ $t('Procced to Checkout') }}</button>

            </div>

          </div>
        </div>







      </div>
    </div>
    <!-- end cart -->

    <!-- profile -->
    <div v-if="this.$localStorage.get(this.$store.storeName) != null" id="popupContainer3" class="popup-container">
      <!-- Pop-up content -->
      <div class="popup-content2" v-if="profile != null">

        <div style=" width: 100%; margin-top: 1%;">
          <button @click="closePopup('popupContainer3')"
            style="float: inline-end; margin-top: -5%; color:#c9c9c9;background-color: transparent; border-color: transparent; font-size: 25px;">x</button>
        </div>

        <div class="offcanvas-header">
          <a role="menuitem" class="te_user_name">
            <span class="fa fa-user-o  icon_user_header">
              <span class="te_user_drop_item_message">{{ $t('hello') }}</span>
            </span>
            <span class="te_user_drop_item">{{ name }}</span>
          </a>
        </div>

        <div class="card_header_item scrollbar">
          <router-link :to="{
            name: 'shopping_cart',
            params: { storeName: this.$store.storeName, lang: $i18n.locale },
          }" role="menuitem" class="list-group-item" @click="closePopup('popupContainer3')">
            <span class="fa fa-shopping-basket me-2 icon_pop3"></span>
            <span class="te_user_drop_item">{{ $t('cart') }}&nbsp;</span>
            <span class="my_cart_quantity" data-order-id="402705">{{ $store.state.cartCounter }}</span>
          </router-link>

          <!--  -->
          <router-link :to="{
            name: 'favourites',
            params: { storeName: this.$store.storeName, lang: $i18n.locale },
          }" role="menuitem" class="list-group-item" @click="closePopup('popupContainer3')">
            <span class="fa fa-heart-o me-2 icon_pop3"></span>
            <span class="te_user_drop_item">{{ $t('favourites') }}&nbsp;</span>
            <span class="my_cart_quantity" data-order-id="402705">{{ profile.fav }}</span>
          </router-link>
          <!--  -->

          <!--  -->
          <router-link :to="{
            name: 'myorders',
            params: { storeName: this.$store.storeName, lang: $i18n.locale },
          }" role="menuitem" class="list-group-item" @click="closePopup('popupContainer3')">
            <span class="fa fa-pie-chart me-2 icon_pop3"></span>
            <span class="te_user_drop_item">{{ $t('orders') }}&nbsp;</span>
            <span class="my_cart_quantity" data-order-id="402705">{{ profile.orders }}</span>
          </router-link>
          <!--  -->

          <router-link :to="{
            name: 'profile',
            params: { storeName: this.$store.storeName, lang: $i18n.locale },
          }" role="menuitem" class="list-group-item" @click="closePopup('popupContainer3')">
            <span class="fa fa-user-o me-2 icon_pop3"></span>
            <span class="te_user_drop_item">{{ $t('profile') }}&nbsp;</span>
          </router-link>


          <router-link :to="{
            name: 'change_password',
            params: { storeName: this.$store.storeName, lang: $i18n.locale },
          }" role="menuitem" class="list-group-item" @click="closePopup('popupContainer3')">
            <span class="fa fa-pencil-square-o me-2 icon_pop3"></span>
            <span class="te_user_drop_item">{{ $t('change_password') }}&nbsp;</span>
          </router-link>


          <router-link :to="{
            name: 'edit_profile',
            params: { storeName: this.$store.storeName, lang: $i18n.locale },
          }" role="menuitem" class="list-group-item" @click="closePopup('popupContainer3')">
            <span class="fa fa-pencil-square-o me-2 icon_pop3"></span>
            <span class="te_user_drop_item">{{ $t('edit profile') }}&nbsp;</span>
          </router-link>

          <a @click="logOut()" role="menuitem" class="list-group-item">
            <span class="fa fa-sign-out me-2 icon_pop3"></span>
            <span class="te_user_drop_item">{{ $t('logout') }}&nbsp;</span>
          </a>

        </div>




      </div>
    </div>
    <!-- end profile -->


    <!-- header -->
    <div id="popupContainer4" class="popup-container">
      <!-- Pop-up content -->
      <div class="popup-content4">

        <div style=" width: 100%; margin-top: 1%;">
          <button @click="closePopup('popupContainer4')"
            style="float: inline-end; margin-top: -5%; color:#c9c9c9;background-color: transparent; border-color: transparent; font-size: 25px;">x</button>
        </div>

        <div class="header_mobile">
          <ul class="header_mobile_list">
            <li class="" @click="activeMobile = false;closePopup('popupContainer4')">
              <div class="d-flex justify-content-between">
                <router-link :to="{
                  name: 'home',
                  params: { storeName: this.$store.storeName, lang: $i18n.locale },
                }">

                  {{ $t('home') }}
                </router-link>
                <router-link :to="{
                  name: 'home',
                  params: { storeName: this.$store.storeName, lang: $i18n.locale },
                }"> <i class="fa fa-angle-right"></i> </router-link>

              </div>
            </li>

            <!-- sections -->
            <li v-for="(item, index) in this.sections" class="">
              <div class="d-flex justify-content-between" id="menu_dropdown">
                <button class="dropdown-toggle" @click="toggleMenu('mobile' + item.id)" type="button"
                  id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false"
                  style="background-color: transparent; border: none;">
                  {{ item.name }}
                </button>
                <a @click="toggleMenu('mobile' + item.id)"> <i class="fa fa-angle-right"></i> </a>


                <ul class="dropdown-menu section_header_item" @mouseleave="closeMenu('mobile' + item.id)"
                  :id="'section_mobile' + item.id" aria-labelledby="dropdownMenuLink" style="width: 100%;">

                  <div v-for="(item2, index2) in item.categories" class="dropdown_contain">
                    <img :src="item2.icon" class="dropdown_img"><br>
                    <router-link @click="activeMobile = false;closePopup('popupContainer4')" :to="{
                      name: 'section',
                      params: {
                        storeName: $store.storeName,
                        id: item.id,
                        name: item.name,
                        lang: $i18n.locale
                      },
                    }" class="dropdown_text" @click.prevent="handleItemClick(item.id)">{{ item2.name
                    }}</router-link>
                  </div>

                </ul>
              </div>
            </li>

            <li class="dropdown" @click="toggleDropdown">
              <button class="d-flex align-items-center lang_btn">
                <p v-if="$i18n.locale == 'en'">English</p>
                <p v-else>العربية</p>
              </button>

              <!-- القائمة المنسدلة -->
              <ul class="dropdown-menu show lang_menue" v-show="isOpen">
                <li><a class="dropdown-item" @click="onChange('ar'); activeMobile = false;closePopup('popupContainer4')">العربية</a></li>
                <li><a class="dropdown-item" @click="onChange('en'); activeMobile = false;closePopup('popupContainer4')">English</a></li>
              </ul>
            </li>
            <!--  -->

            <!--  -->

          </ul>

          <!--  -->
          <div class="logo_mobile">
            <img :src="this.$store.state.logo" />
          </div>
          <!--  -->
        </div>



      </div>
    </div>
    <!-- end header -->

  </div>
</template>

<script>
import item_cart from "../components/cart_item_header.vue";

import Form from "vform";
import { AlertErrors, AlertSuccess } from "vform/src/components/bootstrap5";

export default {
  components: { item_cart, AlertErrors, AlertSuccess },
  data: function () {

    return {
      activeMobile: false,
      name: 'guest',
      profile: null,
      isOpen: false,
      loading_cart: true,
      show_cart: true,
      langChange: '',
      items: [],
      products: [],
      products_list: [],
      sections: [],
      loading: false,
      show: false,
      price: 0,
      word: '',
      countries: [],
      country: 6,
      code: null,
      isValid: true,
      DBitems: null,
      confirmPassword: null,
      errorMessage: "",
      partphone: null,
      finalcode: null,
      passemail: null,
      Newpassword: null,

      form: new Form({
        name: null,
        password: null,
        phone: null,
        phone_basic: null,
        email: null,
        fsm_token: this.$store.state.fsm_token,

      }),
      login_form: new Form({
        email: null,
        password: null,
        fsm_token: this.$store.state.fsm_token
      }),
      loading_register: false,
      loading_reset: false,
      loading_complate_register: false,
      loading_change_password: false,
      loading_code: false,
      countDown: 0,
      loading_login: false,
      loading_reset_code: false,
    };
  },

  methods:
  {
    show_search(){
      var element=document.getElementById('search_div');
      element.style="block"
    },
    close_auth() {
      document.querySelectorAll('.auth_class').forEach(item => {
        item.style.display = "none";
      });
    },
    async sendEmail() {

      this.loading_register = true;

      //if (this.isValid == true) {
      await this.form
        .post(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/genret_code/byemail",
          {
            email: this.form.email,
            //country: this.form.country,
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          if (response.data.code == "-1") {
            console.log(response.data.code);
            this.errorMessage = response.data.message;
            this.loading_register = false;

            setTimeout(() => {
              this.errorMessage = "";
            }, 3000);
          } else if (response.data.code == "1") {

            this.logOutloading_register = false;
            this.openPopup('register_code');
            this.closePopup('register')
            this.countDown = 90;
            this.countDownTimer();


          }
        });

    }
    ,
    updateProducts() {
      // console.log("hiiiiiiiiiiiiiii");
      //this.items = [];
      this.products = [];
      this.price = 0;
      let AllCookies = this.$cookies.keys();
      for (let i = 0; i < AllCookies.length; i++) {
        if (AllCookies[i].split("/")[0] == this.$store.storeName) {
         // this.items.push(AllCookies[i]);
         this.products.push(this.$cookies.get(AllCookies[i]));

          if (this.$cookies.get(AllCookies[i]).offer_price != 0) {
            this.price += this.$cookies.get(AllCookies[i]).offer_price;
          } else {
            this.price += this.$cookies.get(AllCookies[i]).total_price;
          }
          //console.log(this.items);
        }
      }
    },

    openPopup(id) {
      document.getElementById(id).style.display = "block";
      if (id == "popupContainer3") {
        ///////////////////////////////
        this.axios
          .get(
            this.$store.state.base_api_url + this.$store.storeName + "/profile/theme13",
            {
              headers: {
                "Accept-Language": this.$i18n.locale,
                Authorization:
                  "Bearer " + this.$localStorage.get(this.$store.storeName)
              }
            }
          )
          .then(response => {

            this.profile = response.data.data;
            this.name = response.data.data.name;

          })
          .catch(error => {

          });

        //////////////////////////////
      }
    },
    closePopup(id) {
      document.getElementById(id).style.display = "none";
    },
    login_type(id) {
      if (id != 'login') {
        document.getElementById('register2').classList.add("login_active");
        document.getElementById('login2').classList.remove("login_active");
      }
      else {
        document.getElementById('register2').classList.remove("login_active");
        document.getElementById('login2').classList.add("login_active");
      }
    },
    toggleMenu(id) {
      var elements = document.getElementsByClassName('section_header_item');
      for (var i = 0; i < elements.length; i++) {
        elements[i].style = "display:none"
      }
      if (document.getElementById('section_' + id).style.display = "none")
        document.getElementById('section_' + id).style = "display: flex; z-index: 99999;position: absolute;flex-wrap: nowrap;justify-content: center;"
      else
        document.getElementById('section_' + id).style = "display: none;"

    },

    closeMenu(id) {
      console.log('close')
      document.getElementById('section_' + id).style = "display: none;"

    },

    searchRoute() {
      console.log('gggggggggggggggg');
      if (this.$route.path.includes("/" + this.$store.storeName + "/search")) {
        this.$router.push({ name: "search", params: { word: this.word, lang: this.$i18n.locale } });
      } else {
        this.$router.push({
          name: "search",
          params: { storeName: this.$store.storeName, word: this.word, lang: this.$i18n.locale }
        });
      }
    },
    show_cart_fun() {

      this.loading_cart = true;

      if (this.$i18n.locale == 'ar') {
        this.unit = this.$store.state.unitAR;
      }
      else {
        this.unit = this.$store.state.unit;
      }
      {
        let AllCookies = this.$cookies.keys();
        this.products = [];
        this.items=[];

        for (let i = 0; i < AllCookies.length; i++) {
          if (AllCookies[i].split("/")[0] == this.$store.storeName) {
            this.items.push(AllCookies[i]);
            this.products.push(this.$cookies.get(AllCookies[i]));

            if (this.$cookies.get(AllCookies[i]).offer_price != 0) {
              this.price += this.$cookies.get(AllCookies[i]).offer_price;
            } else {
              this.price += this.$cookies.get(AllCookies[i]).total_price;
            }
            //console.log(this.items);
          }
        }
        console.log(this.items);
        this.loading_cart = false;
      }


    },

    onChange(lang) {
      this.$store.state.loading = true;
      this.$store.state.loading_home = true;
      this.$store.state.langchange = true;
      this.$store.state.langchange1 = true;
      //for footer
      this.$i18n.locale = lang;



      if (lang == "ar") {
        this.$store.state.UnitPrice = this.$store.state.unitAR
        document.documentElement.setAttribute("dir", "rtl");
        let h = document.querySelector('body');
        h.setAttribute('dir', 'rtl')

        document.title = this.$store.state.title_ar;
        document.getElementById("description_meta").content = this.$store.state.description_ar;
        document.getElementById("keywords_meta").content = this.$store.state.keyword_ar;
        this.$store.state.routeLang = null
        this.$router.replace({ params: { lang: null } })

      } else {
        this.$store.state.UnitPrice = this.$store.state.unit
        this.$store.state.routeLang = 'en'

        document.documentElement.setAttribute("dir", "ltr");
        let h = document.querySelector('body');
        h.setAttribute('dir', 'ltr')
        document.title = this.$store.state.title_en;
        document.getElementById("description_meta").content = this.$store.state.description_en;
        document.getElementById("keywords_meta").content = this.$store.state.keyword_en;
        this.$router.replace({ params: { lang: this.$store.state.routeLang } })



      }
      // 
      this.axios
        .get(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/theme13/header/sections",
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
            },
          }
        )
        .then((response) => {
          this.sections = response.data.data;
        });

      setTimeout(() => {
        this.$store.state.loading_home = false;
      }, 2500);
      setTimeout(() => {
        this.$store.state.loading = false;
      }, 800);


    },
    logOut() {
      this.loading = true;
      this.axios.get(
        this.$store.state.base_api_url + this.$store.storeName + "/logout",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization:
              "Bearer " + this.$localStorage.get(this.$store.storeName)
          }
        }
      );
      //console.group("hiiiiii")
      console.log(
        "logout:" +
        //this.$localStorage.id() +
        this.$localStorage.get(this.$store.storeName)
      );
      //this.$localStorage.remove("userToken");
      this.show = false;
      let AllCookies = this.$cookies.keys();
      for (let i = 0; i < AllCookies.length; i++) {
        if (AllCookies[i].split("/")[0] == this.$store.state.storeName) {
          this.$cookies.remove(console.log(AllCookies[i]));
        }
        this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie))

      }
      console.log(AllCookies);
      this.$localStorage.remove(this.$store.storeName);
      window.location.href='/new_jasmine';
      this.loading = false;
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    async submitInfo() {
      this.loading_complate_register = true;
      if (this.isValid) {
        if (this.confirmPassword == this.form.password) {
          console.log(this.form.phone)
          {
            this.form.phone = this.$store.state.country_code + this.form.phone_basic
          }
          console.log(this.form.phone)
          const response = await this.form
            .post(
              this.$store.state.base_api_url +
              this.$store.storeName +
              "/register",

              {
                form: this.form,
                headers: {
                  "Accept-Language": this.$i18n.locale,
                },
              }
            )
            .then((response) => {
              this.loading_complate_register = false;

              if (response.data.code == "1") {

                this.$localStorage.set(
                  this.$store.storeName,
                  response.data.data.token
                );
                console.log(
                  this.$localStorage.get(this.$store.storeName) +
                  " id : " +
                  //this.$localStorage.id() +
                  this.$store.storeName
                );

                console.log(
                  "user token : " +
                  this.$localStorage.get(this.$store.storeName)
                );
                /* this.$router.push({
                   name: "home1",
                   params: { storeName: this.$store.storeName },
                 });
                 window.location.reload();*/
                window.location.href = '/new_jasmine';
              } else if (response.data.code == "-1") {
                this.loading_complate_register = false;

                this.errorMessage = response.data.message;
                setTimeout(() => {
                  this.errorMessage = "";
                }, 3000);
              }
              if (response.data.message) {
                this.errorMessage = response.data.message;
                setTimeout(() => {
                  this.errorMessage = "";
                }, 3000);
              }
            });
        } else {
                this.loading_complate_register = true;

          if (this.$i18n.locale == "en") {
            this.errorMessage = "the password not matching";
            setTimeout(() => {
              this.errorMessage = "";
            }, 3000);
          } else {
            this.errorMessage = "كلمتا السر غير متطابقتين";
            setTimeout(() => {
              this.errorMessage = "";
            }, 3000);
          }
        }
      } else {
        if (this.$i18n.locale == "en") {
          this.errorMessage = "your number isn't valid";
          setTimeout(() => {
            this.errorMessage = "";
          }, 3000);
        } else {
          this.errorMessage = "هذا الرقم غير صالح";
          setTimeout(() => {
            this.errorMessage = "";
          }, 3000);
        }
      }
    },

    async submitInfoLogin() {
      this.loading_login = true;
      const response = await this.login_form
        .post(
          this.$store.state.base_api_url + this.$store.storeName + "/login",
          {
            email: this.login_form.email,
            password: this.login_form.password,
            fsm_token: this.login_form.fsm_token,
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          if (response.data.code == "1") {

            this.loading_login = false;
            ////////////// , initializes a session with a 'session-id'.///////////////////
            //this.$localStorage.start();
            this.$localStorage.set(
              this.$store.storeName,
              response.data.data.token
            );
            //this.$localStorage.set("userToken", response.data.data.token);
            console.log(
              this.$localStorage.get(this.$store.storeName) +
              " " +
              this.$store.storeName
            );

            //console.log("login user token : " + this.$session.get("userToken"));
            /*this.$router.push({
              name: "home1",
              params: { storeName: this.$store.storeName },
            });
            window.location.reload();*/
            window.location.href =
              "/new_jasmine";
            //window.location.href= "https://192.168.1.16:8000/"+this.$store.storeName +"/profile"
          } else if (response.data.code == "-1") {
            this.loading_login = false;
            this.errorMessage = response.data.message;
            setTimeout(() => {
              this.errorMessage = "";
            }, 3000);
          }
          if (response.data.error) {
            this.errorMessage = "response.data.error";
            setTimeout(() => {
              this.errorMessage = "";
            }, 3000);
          }
        });
    },

    resetpass() {
      this.loading_reset=true;
      this.axios
        .post(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/forget_password",
          {
            ///update_password
            email: this.passemail
          },
          {
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          if (response.data.code == "1") {
            this.loading_reset=true;
           
            this.countDown = 90;
            this.countDownTimer();
            this.openPopup('reset_code')
            this.closePopup('reset_password');
            

            // console.log(response.data.message);
          } else if (response.data.code == "-1") {
            this.errorMessage = response.data.message;
            setTimeout(() => {
         this.errorMessage = "";
            }, 3000);
          }
          if (response.data.error) {
            this.errorMessage = response.data.message;
            openPopup('login');

            setTimeout(() => {
              this.errorMessage = "";

            }, 3000);
          }
        });
    },
    resetpass1() {
      if (this.isValid == true) {
        this.axios
          .post(
            this.$store.state.base_api_url +
            this.$store.storeName +
            "/forget_password",
            {
              ///update_password
              phone: this.phone
            },
            {
              headers: {
                "Accept-Language": this.$i18n.locale
              }
            }
          )
          .then(response => {
            if (response.data.code == "1") {
              this.forgetVodal = false;
              this.forgetEmailVodal = false;
              this.codeVodal = true;
              this.emailTrue = false;
              this.countDown = 90;
              this.countDownTimer();
              // console.log(response.data.message);
            } else if (response.data.code == "-1") {
              this.errorMessageVodal = response.data.message;
              setTimeout(() => {
                this.errorMessageVodal = "";
              }, 3000);
            }
            if (response.data.error) {
              this.errorMessageVodal = response.data.message;
              setTimeout(() => {
                this.errorMessageVodal = "";
              }, 3000);
            }
          });
      } else {
        if (this.$i18n.locale == "en") {
          this.errorMessageVodal = "your number isn't valid";
          setTimeout(() => {
            this.errorMessageVodal = "";
          }, 3000);
        } else {
          this.errorMessageVodal = "هذا الرقم غير صالح";
          setTimeout(() => {
            this.errorMessageVodal = "";
          }, 3000);
        }
      }
    },
    // check code 

    checkCodeRegister() {
      this.loading_code = true;
      if (this.code != null) {
        console.log('auth:', this.$store.state.auth)
        if (this.$store.state.auth == 1) {
          this.axios
            .post(
              this.$store.state.base_api_url +
              this.$store.storeName +
              "/register_code",
              {
                /*/register_code*/
                phone: this.phone,
                code: this.finalcode,
                fcm_token: this.$store.state.fsm_token
              },
              {
                headers: {
                  "Accept-Language": this.$i18n.locale,
                },
              }
            )
            .then((response) => {
              this.loading_code = false;
              this.countDown = 90;
              this.countDownTimer();

              if (response.data.code == "-1") {
                console.log(response.data.code);
                this.errorMessage = response.data.message;

                setTimeout(() => {
                  this.errorMessage = "";
                }, 3000);
              } else if (response.data.code == "1") {


                // 
                this.openPopup('complate_register');
                this.closePopup('register_code');

                // 

              }
            });
        } else {
          ///for register by email
          this.axios
            .post(
              this.$store.state.base_api_url +
              this.$store.storeName +
              "/register_code/byemail",
              {
                email: this.form.email,
                code: this.code,
              },
              {
                headers: {
                  "Accept-Language": this.$i18n.locale,
                },
              }
            )
            .then((response) => {
              if (response.data.code == "-1") {
                //  console.log( response.data.code);
                this.loading_code = false;
                this.countDown = 90;
                this.countDownTimer();
                this.errorMessage = response.data.message;
                setTimeout(() => {
                  this.errorMessage = "";
                }, 3000);
              } else if (response.data.code == "1") {
                // 
                this.openPopup('complate_register');
                this.closePopup('register_code');

                this.loading_code = false;
                this.countDown = 90;
                this.countDownTimer();

                // 
              }
            });
        }
      } else {
        console.log('gggggggggggg');

        if (this.$i18n.locale == "en") {

          this.validateMessage = "your code isn't complete";
          setTimeout(() => {
            this.validateMessage = "";
          }, 3000);
        } else {
          this.validateMessage = "يرجى إكمال كافة الحقول";
          setTimeout(() => {
            this.validateMessage = "";
          }, 3000);
        }
      }
    },


    // end check code
    checkCode() {
this.loading_reset_code=true;
      this.axios
        .post(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/verivey_reset_password",
          {
            ///update_password
            code: this.finalcode,
            email: this.passemail,
            phone: this.phone
          },
          {
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          this.loading_reset_code=false;
          if (response.data.code == "1") {

            // console.log(response.data.message);
            this.openPopup('change_password');
            this.closePopup('reset_code')
          } else if (response.data.code == "-1") {
            this.errorMessage = response.data.message;
            setTimeout(() => {
              this.errorMessage = "";
            }, 3000);
          }
          if (response.data.error) {
            this.errorMessage = response.data.message;
            setTimeout(() => {
              this.errorMessage = "";
            }, 3000);
          }
        });
    },
    SaveChanges() {
      this.loading_change_password=true;
      if (this.Newpassword != null) {
        this.axios
          .post(
            this.$store.state.base_api_url +
            this.$store.storeName +
            "/update_password",
            {
              ///update_password
              password: this.Newpassword,
              email: this.passemail,
              phone: this.phone,
              fsm_token: this.form.fsm_token
            },
            {
              headers: {
                "Accept-Language": this.$i18n.locale
              }
            }
          )
          .then(response => {
            loading_change_password=false;
            if (response.data.code == "1") {
              // this.forgetVodal = false;
              // this.forgetEmailVodal = false;
              // this.codeVodal = false;
              // this.newPassVodal = false;
              // console.log(response.data.message);

              ////////////// , initializes a session with a 'session-id'.///////////////////
              //this.$localStorage.start();
              this.$localStorage.set(
                this.$store.storeName,
                response.data.data.token
              );
              //this.$localStorage.set("userToken", response.data.data.token);
              console.log(
                this.$localStorage.get(this.$store.storeName) +
                "  " +
                this.$store.storeName
              );
              window.location.href =
                "/new_jasmine";
            } else if (response.data.code == "-1") {
              this.errorMessage = response.data.message;
              setTimeout(() => {
                this.errorMessage = "";
              }, 3000);
            }
            if (response.data.error) {
              this.errorMessage = response.data.message;
              setTimeout(() => {
                this.errorMessage = "";
              }, 3000);
            }
          });
      } else {
        this.errorMessage = "error";
        setTimeout(() => {
          this.errorMessage = "";
        }, 3000);
      }
    },
    ResendCode() {
      let val = {};
      if (this.emailTrue == true) {
        val = { email: this.passemail };
      } else {
        val = { phone: this.phone };
      }
      console.log("val" + val);
      this.axios
        .post(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/forget_password",
          val,
          {
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          if (response.data.code == "-1") {
            this.errorMessage = response.data.message;
            setTimeout(() => {
              this.errorMessageVodal = "";
            }, 3000);
          } else if (response.data.code == "1") {
            this.countDown = 90;
            this.countDownTimer();
            this.errorMessageVodal = response.data.message;
            setTimeout(() => {
              this.errorMessageVodal = "";
            }, 3000);
          }
        });
    },

    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          if (this.countDown > 0) {
            this.countDown -= 1;
            this.countDownTimer();
          }
        }, 1000);
      }
    },
    deleteAllCookies() {

      for (let i = 0; i < this.items.length; i++) {
        this.$cookies.remove(this.items[i]);
      }

      this.items = [];
      this.$store.state.cartCounter = 0;
      this.price = 0;

      // this.loading = false;
      // this.show = false;
    },
    confirmOrder() {
      this.$router.push({
        name: "confirmOrder",
        params: { storeName: this.$store.storeName, lang: this.$i18n.locale },
      })
    },
    confirmOrder_guest() {
      this.$router.push({
        name: "guest_confirmOrder",
        params: { storeName: this.$store.storeName, lang: this.$i18n.locale },
      });
    },

  },
  created() {
    this.loading = true;
    // this.loading_cart=true;
    this.$store.state.cartCounter = 0;
    if (this.$route.params.lang && this.$route.params.lang != this.$i18n.locale) {
      if (this.$route.params.lang == 'en') {
        this.$router.replace({ params: { lang: this.$i18n.locale } })
        this.$i18n.locale = "en"
        document.documentElement.setAttribute("dir", "ltr");
        let h = document.querySelector('body');
        this.$store.state.UnitPrice = this.$store.state.unit;
        $store.state.routeLang = 'en'

      }
      else {
        this.$store.state.UnitPrice = this.$store.state.unitAR;
        $store.state.routeLang = null
      }
    }


    let AllCookies = this.$cookies.keys();
    this.products = [];
    this.items = [];
    this.price = 0;

    for (let i = 0; i < AllCookies.length; i++) {
      console.log('ii ', i)
      if (AllCookies[i].split("/")[0] == this.$store.storeName) {
        // this.items.push(AllCookies[i]);
        this.$store.state.cartCounter += 1;

        // this.products.push(this.$cookies.get(AllCookies[i]));

        // if (this.$cookies.get(AllCookies[i]).offer_price != 0) {
        //   this.price += this.$cookies.get(AllCookies[i]).offer_price;
        // } else {
        //   this.price += this.$cookies.get(AllCookies[i]).total_price;
        // }
      }
    }
    //  this.loading_cart=false


    //////////////////////////
    this.axios
      .get(
        this.$store.state.base_api_url +
        this.$store.storeName +
        "/theme13/header/sections",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
          },
        }
      )
      .then((response) => {
        this.sections = response.data.data;
        console.log('sections', this.sections)
      });

    this.$store.state.langchange = false;

    this.loading = true;


  },
}
</script>